import { locationsData } from '../../locations/Locations';

export interface SupportObj {
    id: string;
    subject: string;
    status: string;
    createdAt: string;
    updatedAt: string | null;
}

export interface SupportTicketFormData {
    description: string;
}

export interface SupportTicketDetailData extends SupportObj {
    description: string;
    messages: SupportTicketMessage[];
}

export interface SupportTicketMessage {
    id: string;
    author: string;
    date: string;
    content: string;
}

export interface AdminUser {
    id: string;
    fullName: string;
    email: string;
    photo_url?: string;
}

export interface SupportTicket {
    id: string;
    subject: string;
    description: string;
    createdBy: string;
    updatedBy: string | null;
    assignTo: string;
    ticketStatus: string;
    createdAt: string;
    updatedAt: string;
    comments: unknown[];
    adminUser: AdminUser;
    location: locationsData;
}

export interface GetSupportTicketApiResponse {
    status: boolean;
    statusCode: number;
    message: string;
    data: SupportTicket[];
}

export const statusFilterOptions = [
    { label: 'Show All', value: '' },
    { label: 'Open', value: 'open' },
    { label: 'Closed', value: 'closed' },
    { label: 'Re Open', value: 're_open' },
];

export interface AdminUser {
    id: string;
    fullName: string;
    email: string;
    photo_url?: string;
}

export interface SupportTicketComment {
    id?: string;
    comment?: string;
    createdAt?: string;
    createdBy?: string;
    adminUser?: AdminUser;
}

export interface SupportTicketDetail {
    id: string;
    subject: string;
    description: string;
    createdBy: string;
    updatedBy: string | null;
    assignTo: string;
    ticketStatus: 'open' | 'closed' | 're_open';
    createdAt: string;
    updatedAt: string;
    comments: SupportTicketComment[];
    adminUser: AdminUser;
}
